// Synchronous payroll reports (payroll-service GET /api/v1/reports/*).
// Same gateway + auth wiring as live.ts: the httpOnly session cookie
// (attachCookieAuth), and a payroll failure must degrade to an error state, not a
// forced logout — so we use a dedicated axios client here too.

import axios from 'axios';
import { apiConfig } from '@/config/api.config';
import { attachCookieAuth } from '@/lib/session';

const http = axios.create({ baseURL: apiConfig.baseURL, timeout: 20000, withCredentials: true });
http.interceptors.request.use(attachCookieAuth);

/** One department/cost-center rollup inside the summary report. */
export interface PayrollSummaryGroup {
  key: string;
  employee_count: number;
  gross: string;
  net: string;
}

/** payroll-service SummaryReport — totals + statutory + groupings for one run. */
export interface PayrollSummaryReport {
  run_id: string;
  period: string;
  currency: string;
  employee_count: number;
  gross: string;
  taxable_income: string;
  total_deductions: string;
  net: string;
  employer_cost: string;
  paye: string;
  nssf_employee: string;
  nssf_employer: string;
  sdl: string;
  wcf: string;
  heslb: string;
  departments: PayrollSummaryGroup[];
  cost_centers: PayrollSummaryGroup[];
}

/** Locked-run payroll summary (run must be validated/approved/locked/paid). */
export const getPayrollSummaryReport = (runId: string) =>
  http
    .get<PayrollSummaryReport>('/api/v1/reports/payroll-summary', { params: { run_id: runId } })
    .then((r) => r.data);
